import React from "react";
import { Box, IconButton } from '@mui/material';
import { LoadingButton as Button } from '@mui/lab';
import { styled } from '@mui/material/styles';
import { setImagevariant } from '../utils/helpers';
import { PlayIcon } from './Icons';
import Img from './Img';

const VideoContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  //borderRadius: '3rem',
  overflow: 'hidden',
  //paddingBottom: '56.25%',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: 'transparent',
  zIndex: 2,
  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
}));

const CoverAction = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 1,
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const Media = React.memo((props) => {

  const { cover, video, autoplay, containerRadius } = props;
  const [ showMedia, setShowMedia ] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const ref = React.useRef();

  const RenderMedia = () => {

    return(
      <>
        {
          (video.provider === 'youtube') && 
          <iframe
            title={video.name}
            onLoad={() => setLoading(false)}
            src={`https://www.youtube.com/embed/${video.key}`}
            //?autoplay=${!!autoplay}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        }
      </>
    );
  };

  return (
    <VideoContainer
      ref={ref}
      sx={{
        paddingBottom: Boolean(video) ? (video.ratio.split(':')[1]/video.ratio.split(':')[0])*100 + '%' : '75%',
        borderRadius: containerRadius,
        backgroundImage: Boolean(cover) ? 'url('+setImagevariant(cover.url, cover.width)+')' : '',
        backgroundColor: 'rgba(0, 0, 0, 0.11)',
        //animation: '1.5s ease-in-out 0.5s infinite normal none running animation-c7515d'
      }}
    >
      { 
        /*(Boolean(video) && ((Boolean(cover) && !showMedia ) || loading)) && 
          <CoverAction>
            <IconButton
              component={Button}
              loading={loading}
              size="large"s
              color="white"
              onClick={() => {
                setLoading(true);
                setShowMedia(true);
              }}
            >
              <PlayIcon fontSize="large" />
            </IconButton>
          </CoverAction>
       
          (Boolean(video) && (!Boolean(cover) || showMedia)) && <RenderMedia /> 
        */
        Boolean(video) && <RenderMedia />
      }
    </VideoContainer>
  );
});

export default Media;